import {QueryBuilderReducerActionTypeEnum, QueryBuilderReducerDispatch, QueryBuilderStateQueryRule} from "../../../../index";
import React, {FunctionComponent, useCallback, useEffect, useState} from "react";
import {DatePicker, DateTimePicker, TimePicker} from "@mui/x-date-pickers";
import {DateUtils, DateUtilsTypes} from "../../../../../base/core";

export interface QueryBuilderValueInputDateProps {
    allowTime?: boolean;
    allowDate?: boolean;
    rule: QueryBuilderStateQueryRule;
    ruleIndex: number;
    conditionIndex: number;
    disabled: boolean;
    dispatch: QueryBuilderReducerDispatch;
}

const valueSetter = (value: string | null) => (value ? DateUtils.serverToUTC(value) : null);

const QueryBuilderValueInputDate: FunctionComponent<QueryBuilderValueInputDateProps> = ({
                                                                                            allowTime = false,
                                                                                            allowDate = false,
                                                                                            dispatch,
                                                                                            disabled,
                                                                                            rule,
                                                                                            ruleIndex,
                                                                                            conditionIndex,
                                                                                        }) => {
    const [value, setValue] = useState<DateUtilsTypes.Instance | null>(null);

    /**
     * With each change in the [rule.value] prop:
     * - updates the local state.
     */
    useEffect(() => {
        setValue(valueSetter(rule.value as string))
    }, [rule.value]);

    /**
     * Commits the rule's value in the reducer for string types.
     */
    const commitDateValue = useCallback((value: DateUtilsTypes.Instance | null) => {
        if (value?.isValid() || !value) {
            setValue(value);
            dispatch({
                type: QueryBuilderReducerActionTypeEnum.ChangeValue,
                payload: {
                    conditionIndex: conditionIndex,
                    ruleIndex: ruleIndex,
                    value: (value === null ? null : DateUtils.UTCToServer(value))?.format(DateUtils.withoutOffsetFormat) ?? "",
                },
            })
        }
    }, [dispatch, conditionIndex, ruleIndex]);

    if (allowDate && allowTime) {
        return (
            <DateTimePicker<DateUtilsTypes.Instance>
                label={'Date Time Value'}
                disabled={disabled}
                value={value}
                onChange={commitDateValue}
                slotProps={{
                    textField: {fullWidth: true, size: 'small'},
                }}
            />
        )
    }
    if (allowDate) {
        return (
            <DatePicker<DateUtilsTypes.Instance>
                label={'Date Value'}
                disabled={disabled}
                value={value}
                onChange={commitDateValue}
                slotProps={{
                    textField: {fullWidth: true, size: 'small'},
                }}
            />
        )
    }
    if (allowTime) {
        return (
            <TimePicker<DateUtilsTypes.Instance>
                label={'Time Value'}
                disabled={disabled}
                value={value}
                onChange={commitDateValue}
                slotProps={{
                    textField: {fullWidth: true, size: 'small'},
                }}
            />
        )
    }

    throw new Error("At least one of [allowDate] and [allowTime] must be true for the date input to work.");
};


export default QueryBuilderValueInputDate;
